import Header from '../components/Header';
import Footer from '../components/Footer';

const FMALCairns = () => {
}

export default FMALCairns;